export const SERVER_DELETE_RESET = 'SERVER_DELETE_RESET'
export const SERVER_DELETE_SET_ERROR = 'SERVER_DELETE_SET_ERROR'
export const SERVER_DELETE_SET_DELETED = 'SERVER_DELETE_SET_DELETED'
export const SERVER_DELETE_TOGGLE_LOADING = 'SERVER_DELETE_TOGGLE_LOADING'
